module.exports = __webpack_public_path__ + "media/images/site/main_image2-846c265649dfb24f37c9a5b850442fc9.jpg";